module.exports = __webpack_public_path__ + "static/media/BOL006-Black.bba0b42f.svg";